import React from 'react';

import { FormattedMessage, defineMessages } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { LogService } from '../../../../services/log-service';
import { settingsTabs } from '../../stores/constants';

const messages = defineMessages({
  changesSaved: {
    description: 'settings.save-bar.changesSaved',
    defaultMessage: 'Changes saved successfully!',
    id: 'fUShA7',
  },
  changesFailed: {
    description: 'settings.save-bar.changesFailed',
    defaultMessage: 'Changes failed to save.',
    id: 'uUCZfU',
  },
});

export const ValidationTabsErrors = {
  [settingsTabs.packingSlips]: 'ControlledValidationError - PackingSlipsTab',
};

const shouldLogError = (e) => {
  if (e.message === ValidationTabsErrors[settingsTabs.packingSlips]) {
    return false;
  }
  return true;
};

export const notifications = {
  success: () => {
    NotificationService.showNotification({
      title: '',
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      content: <FormattedMessage {...messages.changesSaved} />,
      duration: 3000,
    });
  },
  error: (e) => {
    if (shouldLogError(e)) {
      LogService.logError(e);
    }

    NotificationService.showNotification({
      title: '',
      notificationType: NOTIFICATION_TYPE_ERROR,
      content: <FormattedMessage {...messages.changesFailed} />,
      duration: 3000,
    });
  },
};
